import React from 'react'
import Navbar from '../../../Components/Navbar/Navbar'
import HeroTC from './HeroTC'
import TermsConditionContent from './term-condition-content'
import Footer from '../../../Components/Footer/Footer';

const TermsCondition = () => {
  return (
    <div>
        <Navbar></Navbar>
        <HeroTC></HeroTC>
        <TermsConditionContent></TermsConditionContent>
        <Footer></Footer>
        
    </div>
  )
}

export default TermsCondition